export const roleDetails = [
  {
    roleName: "Camera",
    roleDescription: "Createing the role for Camera.",
    createdDateTime: "3/02/2023,4:00pm",
    roleStatus: "Active",
  },
  {
    roleName: "ECB",
    roleDescription: "Createing the role for ECB.",
    createdDateTime: "3/02/2023,4:00pm",
    roleStatus: "Deactive",
  },
  {
    roleName: "Light",
    roleDescription: "Createing the role for light.",
    createdDateTime: "3/02/2023,4:00pm",
    roleStatus: "Active",
  },
  {
    roleName: "Light",
    roleDescription: "Createing the role for light.",
    createdDateTime: "3/02/2023,4:00pm",
    roleStatus: "Active",
  },
  {
    roleName: "Light",
    roleDescription: "Createing the role for light.",
    createdDateTime: "3/02/2023,4:00pm",
    roleStatus: "Active",
  },
];

export const roleTableDatacolumnsForExport = [
  { label: "Role Name", key: "name" },
  { label: "Role Description", key: "description" },
  { label: "Created For", key: "is_admin" },
  { label: "Created By", key: "created_by_username" },
  { label: "Created On", key: "createdOn" },
  { label: "Permissions", key: "role_permission" },
];
